// src/api/sections.ts

import { createAuthenticatedFetch } from '@/api/types/core/common';
import type { Section, SectionCreate, SectionWithTranslations } from './types/core/sections';

// @deprecated Use imports from '@/api/types' instead
export type {
  Section,
  SectionCreate,
  SectionWithTranslations,
};

const api = createAuthenticatedFetch();

// Objet principal contenant toutes les fonctions
export const sections = {
  async fetchSections(): Promise<Section[]> {
    try {
      return await api.get('/sections/');
    } catch (error) {
      throw new Error("Erreur lors de la récupération des sections");
    }
  },

  async fetchAllSections(): Promise<Section[]> {
    try {
      return await api.get('/sections/all');
    } catch (error) {
      throw new Error("Erreur lors de la récupération des sections");
    }
  },

  async fetchFieldsByLanguage(language: string): Promise<SectionWithTranslations[]> {
    try {
      return await api.get(`/sections_with_translations/${language}`);
    } catch (error) {
      throw new Error("Erreur lors de la récupération des sections");
    }
  },

  async updateSection(sectionId: number, sectionData: Partial<SectionCreate>): Promise<Section> {
    try {
      return await api.put(`/sections/${sectionId}`, sectionData);
    } catch (error) {
      throw new Error("Erreur lors de la mise à jour de la section");
    }
  },

  async createSections(sectionsData: SectionCreate[]): Promise<Section[]> {
    try {
      return await api.post('/sections/', { sections: sectionsData });
    } catch (error) {
      throw new Error("Erreur lors de la création des sections");
    }
  },

  async deleteSection(sectionId: number): Promise<void> {
    try {
      await api.delete(`/sections/${sectionId}`);
    } catch (error) {
      throw new Error("Erreur lors de la suppression de la section");
    }
  }
};

// Exports des fonctions individuelles pour la rétrocompatibilité
export const fetchSections = (): Promise<Section[]> => sections.fetchSections();
export const fetchAllSections = (): Promise<Section[]> => sections.fetchAllSections();
export const fetchFieldsByLanguage = (language: string): Promise<SectionWithTranslations[]> => sections.fetchFieldsByLanguage(language);
export const updateSection = (sectionId: number, sectionData: Partial<SectionCreate>): Promise<Section> => sections.updateSection(sectionId, sectionData);
export const createSections = (sectionsData: SectionCreate[]): Promise<Section[]> => sections.createSections(sectionsData);
export const deleteSection = (sectionId: number): Promise<void> => sections.deleteSection(sectionId);